import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BlogCard from '../components/BlogCard';

const initialPosts = [
  {
    id: 1,
    slug: "optimizing-react-performance",
    title: "Beyond useMemo: Real-world React Performance Optimization",
    excerpt: "Stop blindly sprinkling useMemo everywhere. Here is a deep dive into how React rendering actually works and the practical steps to fix application bottlenecks.",
    date: "Oct 24, 2023",
    readTime: "8 min read",
    category: "Architecture"
  },
  {
    id: 2,
    slug: "building-cli-rust",
    title: "Why I rewrote my Node.js CLI tool in Rust",
    excerpt: "A post-mortem on migrating a complex file processing utility. We cover the pain points of the original architecture, the learning curve of Rust, and the 40x performance gain.",
    date: "Sep 12, 2023",
    readTime: "12 min read",
    category: "Rust"
  },
  {
    id: 3,
    slug: "monetizing-indie-apps",
    title: "The Indie Dev Guide to Pricing Software",
    excerpt: "Pricing is hard. After launching 5 micro-SaaS products, here is what I learned about lifetime deals, subscription fatigue, and finding your true target audience.",
    date: "Aug 05, 2023",
    readTime: "6 min read",
    category: "Marketing"
  },
  {
    id: 4,
    slug: "css-grid-layouts",
    title: "CSS Grid Layouts you'll actually use",
    excerpt: "Forget the complex 12-column frameworks. These 5 CSS Grid snippets solve 90% of the layout problems you will encounter building modern web apps.",
    date: "Jul 18, 2023",
    readTime: "5 min read",
    category: "Design"
  }
];

const Blog = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredPosts = initialPosts.filter(post => 
    post.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
    post.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="max-w-4xl mx-auto space-y-12">
      {/* Header */}
      <div>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Writing & Insights</h1>
        <p className="text-xl text-slate-400">
          Long-form thoughts on software engineering, product design, and the indie hacking journey.
        </p>
      </div>

      {/* Search Bar */}
      <div className="relative">
        <SafeIcon icon={FiIcons.FiSearch} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 text-lg" />
        <input 
          type="text" 
          placeholder="Search articles by title or topic..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full bg-slate-900/50 border border-slate-700 rounded-xl py-4 pl-12 pr-4 text-slate-200 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all placeholder:text-slate-600 glass-card"
        />
      </div>

      {/* Articles List */}
      <div className="space-y-2">
        {filteredPosts.length > 0 ? (
          filteredPosts.map((post, index) => (
            <motion.div
              key={post.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <BlogCard post={post} />
            </motion.div>
          ))
        ) : (
          <div className="text-center py-12 text-slate-500">
            <SafeIcon icon={FiIcons.FiInbox} className="text-4xl mx-auto mb-4 opacity-50" />
            <p>No articles found matching "{searchTerm}"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;